export interface LocationData {
  latitude: number
  longitude: number
  accuracy: number
  timestamp: number
}

export const getCurrentLocation = async (): Promise<LocationData | null> => {
  if (!('geolocation' in navigator)) {
    console.log('Geolocation is not supported by this browser')
    return null
  }

  try {
    const position = await new Promise<GeolocationPosition>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        resolve,
        reject,
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      )
    })

    return {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      accuracy: position.coords.accuracy,
      timestamp: position.timestamp
    }
  } catch (error) {
    console.error('Error getting location:', error)
    
    // Return null on error - we don't want to block clock in/out
    // if location fails
    return null
  }
}

export const requestLocationPermission = async (): Promise<PermissionState | null> => {
  try {
    const result = await navigator.permissions.query({ name: 'geolocation' })
    return result.state
  } catch (error) {
    console.error('Error checking location permission:', error)
    return null
  }
}